import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { forwardRef } from 'react';
import { headingSizes } from '@atlaskit/theme/typography';
import { itemTextColor } from '../../common/constants';
import { overrideStyleFunction } from '../../common/styles';
import { CustomItem } from '../Item';

var Container = function Container(props) {
  return /*#__PURE__*/React.createElement("div", props);
};

var Header = /*#__PURE__*/forwardRef(function (props, ref) {
  var cssFn = overrideStyleFunction(function (currentStyles) {
    var _objectSpread2;

    return _objectSpread(_objectSpread({}, currentStyles), {}, (_objectSpread2 = {
      userSelect: 'auto'
    }, _defineProperty(_objectSpread2, '[data-item-title]', {
      fontSize: headingSizes.h400.size,
      letterSpacing: '-0.003em',
      fontWeight: 600,
      color: itemTextColor
    }), _defineProperty(_objectSpread2, 'div&:hover', {
      backgroundColor: 'transparent',
      cursor: 'default'
    }), _defineProperty(_objectSpread2, 'div&:active', {
      backgroundColor: 'transparent',
      color: itemTextColor
    }), _objectSpread2));
  }, props.cssFn);
  return /*#__PURE__*/React.createElement(CustomItem, _extends({}, props, {
    ref: ref,
    component: props.component || Container,
    cssFn: cssFn,
    overrides: {
      Title: {
        render: function render(_, _ref) {
          var children = _ref.children,
              props = _objectWithoutProperties(_ref, ["children"]);

          return /*#__PURE__*/React.createElement("h2", props, children);
        }
      }
    }
  }));
});
export default Header;